var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 26,
    viewBox: "0 0 32 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.941 25.754L0 13.812l5.695-5.695 6.246 6.246L26.305 0 32 5.695z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIyNiIgdmlld0JveD0iMCAwIDMyIDI2Ij4KICA8cG9seWdvbiBwb2ludHM9IjExLjk0MSAyNS43NTQgMCAxMy44MTIgNS42OTUgOC4xMTcgMTEuOTQxIDE0LjM2MyAyNi4zMDUgMCAzMiA1LjY5NSIvPgo8L3N2Zz4K";
export { SvgCheck as ReactComponent };